import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

import Loading from '../common/Loading';
import Footnote from '../Footnote';

import utils from '../../lib/utils';
import reportDownload from '../../assets/images/report-download.svg';

import './index.scss';

const report_list = [
  // {
  //   title: 'Performance Summary',
  //   download_enable_flag: 'performance_summary',
  //   description: 'High-level summary of performance across all business locations associated with your account.'
  // },
  // {
  //   title: 'Setup and Alerts Summary',
  //   download_enable_flag: 'setup_summary',
  //   description: 'Summary of setup and alerts across all business locations associated with your account.'
  // },
  // {
  //   title: 'Utilization Summary',
  //   download_enable_flag: 'utilisation_summary',
  //   description: 'Summary of TrueLark utilization across all business locations associated with your account.'
  // },
  {
    title: 'Lead Engage Summary',
    download_enable_flag: 'lead_engage_enabled',
    description: 'Summary of Lead Engage performance across all business locations associated with your account.',
    download_path: '/analytics/lead_engage/report'
  },
  {
    title: 'AI Reminders Summary',
    download_enable_flag: 'appointment_reminder_enabled',
    description: 'Summary of Reminders performance across all business locations associated with your account.',
    download_path: '/analytics/reminder/report'
  }
];

export default class BrandAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  componentDidMount() {
    const { analytics, getAllowedAnalyticsReport } = this.props;
    const { isFetchingList, isListFetched } = analytics;
    if (!isListFetched && !isFetchingList) {
      getAllowedAnalyticsReport();
    }
  }

  downloadReport = (download_path, isDisabled) => {
    if (!isDisabled) {
      const { auth, business } = this.props;
      const business_id = auth.studio_id || business.id;
      let constructed_path = download_path;
      if (constructed_path === "/analytics/lead_engage/report") {
        constructed_path = `/business/lead_engage/brand/${business_id}/brand_le_summary_report`;
      }
      const URL = window.Config.API_URL + constructed_path;
      window.open(URL, '_blank');
    }
  };

  render() {
    const loading = false;
    const showDownloads = true;
    const { analytics } = this.props;
    const { isFetchingList, isListFetched, allowdAnalyticsList } = analytics;
    return (
      <div className="brand-analytics-container">
        {isFetchingList ? (
          <div className="loading-container">
            <Loading />
          </div>
        ) : (
          <>
            <div className="brand-analytics-header"></div>
            <div className="brand-analytics">
              <div className="brand-analytics__overview">
                <div className="title">
                  <div>
                    <span>Analytics</span>
                  </div>
                </div>
              </div>
              {isListFetched && (
                <div className='brand-analytics__report'>
                  <div className='brand-analytics__report_content'>
                    <div className='column-titles'>
                      <div className='title name'>NAME</div>
                      <div className='title description'>DESCRIPTION</div>
                      <div className='title download'>REPORT</div>
                    </div>
                    <div className='list-container'>
                      {report_list.map(report => {
                        return (<div className='column-data'>
                          <div className='name'>
                            {report.title}
                          </div>
                          <div className='description'>
                            {report.description}
                          </div>
                          <div className={classnames('download', { 'disabled': !allowdAnalyticsList[report.download_enable_flag] })} disabled={!allowdAnalyticsList[report.download_enable_flag]} onClick={() => this.downloadReport(report.download_path, !allowdAnalyticsList[report.download_enable_flag])}>
                            <img src={reportDownload} /> Download
                          </div>
                        </div>)
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        <Footnote />
      </div>
    );
  }
}

BrandAnalytics.defaultProps = {
  getAllowedAnalyticsReport: () => { },
};

BrandAnalytics.propTypes = {
  getAllowedAnalyticsReport: PropTypes.func,
};
